import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportHistoryCheckBranches } from '@api/hitoryCheck';

import { ICMBranchesExportDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { ESnackbarTypes } from '@enums/common';

import { HC_BRANCHES_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportHcBranches = () => {
	const dispatch = useAppDispatch();

	const { mutate: exportBranches } = useMutation<ICMBranchesExportDTO>({
		mutationKey: [HC_BRANCHES_EXPORT],
		mutationFn: exportHistoryCheckBranches,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportBranches };
};
